import { axiosCall } from "./apiRequest";
import { baseUrl } from "./helper";
import FormData from "form-data";

export const getInvoiceCompanyAndClient = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const companyList = await axiosCall(
      baseUrl + "invoice/get-company-list",
      "get",
      "",
      header
    );
    const clientList = await axiosCall(
      baseUrl + "invoice/get-client-list",
      "get",
      "",
      header
    );
    return { companyList, clientList };
  } catch (error) {
    throw error;
  }
};

export const getInvoiceCompany = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const companyList = await axiosCall(
      baseUrl + "invoice/get-company-list",
      "get",
      "",
      header
    );
    // const clientList = await axiosCall(baseUrl + "invoice/get-client-list", "get", "", header);
    return { companyList };
  } catch (error) {
    throw error;
  }
};

export const createInvoicePost = async (userData) => {
  try {
    const formData = new FormData();
    Object.keys(userData).forEach(async (key) => {
      if (key == "items") {
        userData[key].forEach((item, index) => {
          // Here, we are appending each item as a separate form field
          // You can customize the field names based on your backend needs
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][description]`, item.description);
          formData.append(`items[${index}][hsn_code]`, item.hsn_code);
          formData.append(`items[${index}][gst_rate]`, item.gst_rate);
          formData.append(`items[${index}][quantity]`, item.quantity);
          formData.append(`items[${index}][unit_price]`, item.unit_price);
        });
      } else {
        formData.append(key, userData[key]);
      }
    });
    // console.log({formData});

    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "vendor/invoices/add",
      "post",
      formData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createPoFile = async (userData) => {
  try {
    const formData = new FormData();
    Object.keys(userData).forEach((key) => {
      if (key === "items") {
        userData[key].forEach((item, index) => {
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][description]`, item.description);
          formData.append(`items[${index}][hsn_code]`, item.hsn_code);
          formData.append(`items[${index}][gst_rate]`, item.gst_rate);
          formData.append(`items[${index}][quantity]`, item.quantity);
          formData.append(`items[${index}][unit_price]`, item.unit_price);
        });
      } else {
        formData.append(key, userData[key]);
      }
    });

    console.log({ formData });

    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "poroute/po/add",
      "post",
      formData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInvoiceList = async (page) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "vendor/invoices/list/1" ,
      "get",
      {},
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getFinanceInvoiceList = async (data) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "vendor/invoice-list",
      "post",
      data,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateInvoiceStatus = async (data) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "vendor/invoices/status/update",
      "post",
      data,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDashboardData = async () => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "vendor/invoices/dashboard",
      "get",
      {},
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getlastSixMonthInvoice = async () => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "vendor/invoices/last-six-months",
      "get",
      {},
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};
